<template>
  <Layout>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalEditSelectionProcess" ref="modalEditSelectionProcess" size="lg" title="Edit Selection Process">
      <b-tabs card content-class="mt-2" justified>
        <b-tab title="Selection Process" active>
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="title">Title <span class="text-danger">*</span></label>
                <div class="input-group">
                  <b-form-input id="Email" v-model="formSelectionProcess.title"
                    :state="$v.formSelectionProcess.title.$dirty ? !$v.formSelectionProcess.title.$error : null"
                    type="text" class="form-control" maxlength="300" />
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="8" md="8" lg="8" xl="8">
              <div class="form-group">
                <label for="position">Position <span class="text-danger">*</span></label>
                <div class="input-group">
                  <b-form-input id="Email" v-model="formSelectionProcess.position"
                    :state="$v.formSelectionProcess.position.$dirty ? !$v.formSelectionProcess.position.$error : null"
                    type="text" class="form-control" maxlength="200" />
                </div>
              </div>
            </b-col>
            <b-col cols="12" sm="4" md="4" lg="4" xl="4">
              <div class="form-group">
                <label for="endDate">Estimated End Date <span class="text-danger">*</span></label>
                <b-input-group class="mb-3">
                  <b-form-input id="endDate" v-mask="['##/##/####']" type="text" placeholder="DD/MM/YYYY"
                    autocomplete="off" :value="formSelectionProcess.endDate"
                    :state="$v.formSelectionProcess.endDate.$dirty ? !$v.formSelectionProcess.endDate.$error : null"
                    @blur="onBlurEndDate">
                  </b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker 
                      :value="endDateVal" 
                      :min="new Date()" 
                      button-only close-button locale="pt" right
                      :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                      @input="updateEndDate">
                    </b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="6" md="6" lg="6" xl="6">
              <div class="form-group">
                <label for="position">Status</label>
                <div class="input-group">
                  <b-form-select v-model="formSelectionProcess.selectionProcessStatusId" :options="status"
                    value-field="id" text-field="value"></b-form-select>
                </div>
              </div>
            </b-col>
            <b-col v-if="formSelectionProcess.selectionProcessStatusId === 1" xs="12" sm="6" md="6" lg="6" xl="6">
              <div class="form-group">
                <label for="position">Ongoing Status</label>
                <div class="input-group">
                  <b-form-select v-model="formSelectionProcess.selectionProcessOnGoingStatusId" :options="statusOngoing"
                    value-field="id" text-field="value"></b-form-select>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="status">Confidential (HR personnel from other AFPs can view this selection process).
                </label>
                <div class="input-group">
                  <b-form-checkbox v-model="formSelectionProcess.confidential" switch size="lg"
                    :value="true"></b-form-checkbox>
                </div>
              </div>
            </b-col>
            <b-col xs="12" sm="12" md="12" lg="12" xl="12">
              <div class="form-group">
                <label for="status">General Comments</label>
                <div class="input-group">
                  <b-form-textarea id="textarea-default" v-model="formSelectionProcess.comments"
                    rows="6"></b-form-textarea>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="formSelectionProcess.id" title="Files" >
          <div class="card-body">
              <h5 class="card-title">Files</h5>
              <b-row>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <div class="col-md-12">
                    <b-table hover :items="fileItems" :fields="fileFields">
                      <template v-slot:cell(Options)="row">
                        <b-button v-b-tooltip.hover title="Download" variant="success" size="xs"
                          @click="downloadFile(row.item.file)"><i class="fas fa-download"></i></b-button>
                        <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" class="ml-1"
                          @click="editFile(row.item.file)"><i class="far fa-edit"></i></b-button>
                        <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-1"
                          @click="deleteFile(row.item.file)"><i class="far fa-trash-alt"></i></b-button>
                      </template>
                    </b-table>
                    <b-button variant="primary" @click="addFile">Add file</b-button>
                  </div>
                </b-col>
              </b-row>
            </div>

        </b-tab>
        <b-tab v-if="formSelectionProcess.id && !formSelectionProcess.confidential" title="Publish">
          <b-row>
            <b-col xs="4" sm="4" md="4" lg="4" xl="4">
              <div class="form-group">
                <label for="status">Publish </label>
                <div class="input-group">
                  <b-form-checkbox v-model="formSelectionProcess.publish" switch size="lg"
                    :value="true"></b-form-checkbox>
                </div>
              </div>
            </b-col>
            <b-col v-if="formSelectionProcess.publish" cols="4" sm="4" md="4" lg="4" xl="4">
              <div class="form-group">
                <label for="startPublish">Start</label>
                <b-input-group class="mb-3">
                  <b-form-input id="startPublish" v-mask="['##/##/####']" type="text" placeholder="DD/MM/YYYY"
                    autocomplete="off" :value="formSelectionProcess.startPublish"
                    :state="$v.formSelectionProcess.startPublish.$dirty ? !$v.formSelectionProcess.startPublish.$error : null"
                    @blur="onBlurStartPublish">
                  </b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker :value="startPublishVal" :min="new Date()" :max="endPublishVal"  button-only close-button locale="pt" right
                      :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                      @input="updateStartPublish">
                    </b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
            <b-col v-if="formSelectionProcess.publish" cols="4" sm="4" md="4" lg="4" xl="4">
              <div class="form-group">
                <label for="endPublish">End</label>
                <b-input-group class="mb-3">
                  <b-form-input id="endPublish" v-mask="['##/##/####']" type="text" placeholder="DD/MM/YYYY"
                    autocomplete="off" :value="formSelectionProcess.endPublish" 
                    :state="$v.formSelectionProcess.endPublish.$dirty ? !$v.formSelectionProcess.endPublish.$error : null"
                    @blur="onBlurEndPublish">
                  </b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker :value="endPublishVal" :min="startPublishVal" button-only close-button locale="pt" right
                      :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                      @input="updateEndPublish">
                    </b-form-datepicker>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-col>
           
          </b-row>
        </b-tab>
        <b-tab v-if="formSelectionProcess.selectionProcessStatusHistory" title="Status History Log">
          <div v-if="formSelectionProcess.selectionProcessStatusHistory.length === 0" class="alert alert-info">Not
            found.
          </div>
          <div v-else>
            <b-table responsive show-empty hover :items="formSelectionProcess.selectionProcessStatusHistory"
              :fields="historyFields">
              <template v-slot:cell(to)="row">
                <span v-if="row.item.selectionProcessStatus">{{ row.item.selectionProcessStatus.description }}</span>
                <span v-if="row.item.selectionProcessOnGoingStatus"> ({{
                  row.item.selectionProcessOnGoingStatus.description }})</span>
              </template>
              <template v-slot:cell(on)="row">
                {{ row.item.createdAt | formatDateTime }}
              </template>
              <template v-slot:cell(by)="row">
                {{ row.item.createdBy.name }} {{ row.item.createdBy.surname }}
              </template>
            </b-table>
          </div>
        </b-tab>
      </b-tabs>
      <template slot="modal-footer">
        <b-button variant="primary" class="mr-2" @click="confirmEditSelectionProcess">Save</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('modalEditSelectionProcess')">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalViewSelectionProcess" ref="modalViewSelectionProcess" size="lg" title="Selection Process">
      <SelectionProcess :id="idSelected" :public=false></SelectionProcess>
      <template slot="modal-footer">
        <b-button variant="secondary" @click="$bvModal.hide('modalViewSelectionProcess')">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalFile" ref="modalFile" size="lg" title="File">

      <b-container fluid>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label>File <span class="text-danger">*</span></label>
              <div class="input-group">
                <b-form-file v-model="file.file" :state="$v.file.file.$dirty ? !$v.file.file.$error : null"
                  placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label>Name <span class="text-danger">*</span></label>
              <div class="input-group">
                <b-form-input id="name-input" v-model="file.name"
                  :state="$v.file.name.$dirty ? !$v.file.name.$error : null"></b-form-input>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label>Description</label>
              <b-form-textarea id="textarea-default" v-model="file.description" maxlength="500"></b-form-textarea>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer>
        <b-button type="submit" variant="primary" class="mr-2" @click="saveFile">Save</b-button>
        <b-button variant="secondary" @click="hideModalFile">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalconfirmDelete" ref="modalconfirmDelete" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>File:</b> {{ file.originalName }}</p>
      <p><b>Name:</b> {{ file.name }}</p>
      <p><b>Description:</b> {{ file.description }}</p>
      <template slot="modal-footer">
        <b-button variant="primary" class="mr-2" @click="confirmDelete">Confirm</b-button>
        <b-button variant="secondary" @click="hideConfirmDelete">Close</b-button>
      </template>
    </b-modal>
    <PageHeader title="Selection Process" />
    <div v-if="!showCurriculumManager">
      <div class="row">
        <div class="col-md-12">
          <b-card title="Search form">
            <b-form @submit.prevent="searchAll">
              <div class="row">
                <b-col xs="12" sm="4" md="4" lg="4" xl="4">
                  <div class="form-group">
                    <label>Title</label>
                    <div class="input-group">
                      <b-form-input v-model="formSearch.title"></b-form-input>
                    </div>
                  </div>
                </b-col>
                <b-col xs="12" sm="4" md="4" lg="4" xl="4">
                  <div class="form-group">
                    <label>AFP</label>
                    <div class="input-group">
                      <b-form-select v-model="formSearch.agencyId" :options="agencies" value-field="id"
                        text-field="name" selected="null">
                        <template v-slot:first>
                          <b-form-select-option :value="null" selected>
                            -- All --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                  </div>
                </b-col>
                <b-col xs="12" sm="4" md="4" lg="4" xl="4">
                  <div class="form-group">
                    <label>Status</label>
                    <div class="input-group">
                      <b-form-select v-model="formSearch.SelectionProcessStatusId" :options="status" value-field="id"
                        text-field="value">
                        <template v-slot:first>
                          <b-form-select-option :value="null" selected>
                            -- All --
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                  </div>
                </b-col>
              </div>
              <div class="row">
                <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="mt-1">
                  <b-button type="submit" variant="primary"><i class="fas fa-search"></i> Search</b-button>
                  <b-button variant="outline-secondary" class="ml-2" @click="clearForm"><i class="fas fa-eraser"></i>
                    Clear
                    Form</b-button>
                  <b-button variant="secondary" class="ml-2" @click="exportData"><i class="fas fa-save"></i>
                    Export</b-button>
                  <b-button variant="submit" class="ml-2">
                    <b-link target="_blank" to="selection-process-list"><i class="fas fa-search"></i> View
                      Published</b-link></b-button>
                </b-col>
                <b-col xs="12" sm="6" md="6" lg="6" xl="6" class="mt-1">
                  <b-button class="float-right" variant="success" @click="openModalAddSelectionProcess">Add Selection
                    Process</b-button>
                </b-col>

              </div>
            </b-form>
          </b-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card title="Search result">
            <b-tabs content-class="mt-3">
              <b-tab title="Active" active>
                <div v-if="totalItems === 0" class="alert alert-info">No results found for this criteria.</div>
                <div v-else>
                  <b-table responsive show-empty hover :items="searchResult" :fields="searchResultFields"
                    :current-page="currentPage" :per-page="0">
                    <template v-slot:cell(edit)="row">
                      <b-button v-b-tooltip.hover title="View" variant="info" size="xs" class="ml-1"
                        @click="viewSelectionProcess(row.item)"><i class="fa fa-search"></i></b-button>
                      <b-button v-b-tooltip.hover title="Curriculums" variant="primary" size="xs" class="ml-1"
                        @click="editCandidates(row.item)"><i class="fas fa-users"></i></b-button>
                      <b-button v-if="row.item.agencyId === currentAgency.id" v-b-tooltip.hover title="Edit"
                        variant="primary" size="xs" class="ml-1" @click="editSelectionProcess(row.item)"><i
                          class="far fa-edit"></i></b-button>
                      <b-button v-if="row.item.agencyId === currentAgency.id" v-b-tooltip.hover title="Remove"
                        variant="danger" size="xs" class="ml-1"
                        @click="changeStatusSelectionProcess(row.item.id, false)"><i
                          class="far fa-trash-alt"></i></b-button>
                    </template>
                    <template v-slot:cell(publish)="row">
                      {{ row.item.publish | formatYesNo }}
                    </template>
                    <template v-slot:cell(confidential)="row">
                      {{ row.item.confidential | formatYesNo }}
                    </template>
                    <template v-slot:cell(startPublish)="row">
                      {{ row.item.startPublish | formatDate }}
                    </template>
                    <template v-slot:cell(endDate)="row">
                      {{ row.item.endDate | formatDate }}
                    </template>                    
                    <template v-slot:cell(updatedby)="row">
                      {{ row.item.updatedBy.name }} {{ row.item.updatedBy.surname }}<br>
                      <b-badge variant="light">{{ row.item.updatedAt | formatDateTime }}</b-badge>
                    </template>
                    <template v-slot:cell(status)="row">
                      <span v-if="row.item.selectionProcessStatus">
                        {{ row.item.selectionProcessStatus.description }}
                      </span><br>
                      <b-badge v-if="row.item.selectionProcessStatusId === 1" variant="light">
                        <span v-if="row.item.selectionProcessOnGoingStatus">
                          {{ row.item.selectionProcessOnGoingStatus.description }}
                        </span>
                      </b-badge>
                    </template>
                  </b-table>
                  <b-pagination v-if="pageCount > 1" v-model="currentPage" size="md" :total-rows="totalItems"
                    :per-page="perPage" class="d-flex justify-content-center"></b-pagination>
                </div>
              </b-tab>
              <b-tab title="Removed">
                <div v-if="totalItemsDeleted === 0" class="alert alert-info">No results found for this criteria.</div>
                <div v-else>
                  <b-table responsive show-empty hover :items="searchResultDeleted" :fields="searchResultFields"
                    :current-page="currentPage" :per-page="0">
                    <template v-slot:cell(edit)="row">
                      <b-button v-b-tooltip.hover title="View" variant="info" size="xs" class="ml-1"
                        @click="viewSelectionProcess(row.item)"><i class="fa fa-search"></i></b-button>
                      <b-button v-if="row.item.agencyId === currentAgency.id" v-b-tooltip.hover title="Restore"
                        variant="primary" size="xs" class="ml-1"
                        @click="changeStatusSelectionProcess(row.item.id, true)"><i
                          class="fas fa-trash-restore"></i></b-button>
                    </template>
                    <template v-slot:cell(confidential)="row">
                      {{ row.item.confidential | formatYesNo }}
                    </template>
                    <template v-slot:cell(startPublish)="row">
                      {{ row.item.startPublish | formatDate }}
                    </template>
                    <template v-slot:cell(endDate)="row">
                      {{ row.item.endDate | formatDate }}
                    </template>
                    <template v-slot:cell(updatedby)="row">
                      {{ row.item.updatedBy.name }} {{ row.item.updatedBy.surname }}<br>
                      <b-badge variant="light">{{ row.item.updatedAt | formatDateTime }}</b-badge>
                    </template>
                  </b-table>
                  <b-pagination v-if="pageCountDeleted > 1" v-model="currentPage" size="md"
                    :total-rows="totalItemsDeleted" :per-page="perPage"
                    class="d-flex justify-content-center"></b-pagination>
                </div>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
    </div>
    <div v-else>
      <CurriculumManager :id="idSelected" @callback="showManager"></CurriculumManager>
    </div>
  </Layout>
</template>

<script>
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import SelectionProcess from './SelectionProcess.vue'
import CurriculumManager from './CurriculumManager.vue'
import moment from 'moment'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
var qs = require('qs')

export default {
  components: { Layout, PageHeader, loading, SelectionProcess, CurriculumManager },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  data() {
    return {
      fileFields: [
        {
          key: 'file.name',
          label: 'Name'
        },
        {
          key: 'file.description',
          label: 'Description'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ],
      fileItems: [],
      file: {},
      newFile: false,
      showCurriculumManager: false,
      formSearch: {
        agencyId: null,
        SelectionProcessStatusId: null
      },
      ongoing: false,
      formSelectionProcess: {},
      idSelected: '',
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      agencies: [],
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      pageCount: 1,
      currentPageDeleted: 1,
      perPageDeleted: 10,
      totalItemsDeleted: 0,
      pageCountDeleted: 1,
      searchResult: [],
      statusOngoing: [],
      status: [],
      historyFields: [
        {
          key: 'to',
          label: 'Modified To'
        },
        {
          key: 'on',
          label: 'Modified On'
        },
        {
          key: 'by',
          label: 'Modified by'
        }
      ],
      searchResultDeleted: [],
      searchResultFields: [
        {
          key: 'sequenceId',
          label: 'ID'
        },
        {
          key: 'agency.name',
          label: 'AFP'
        },
        {
          key: 'title',
          label: 'Title'
        },
        {
          key: 'position',
          label: 'Position'
        },
        {
          key: 'startPublish',
          label: 'Start Publish'
        },
        {
          key: 'endDate',
          label: 'Estimated End Date'
        },
        {
          key: 'updatedby',
          label: 'Last Updated By'
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'publish',
          label: 'Published'
        },
        {
          key: 'confidential',
          label: 'Confidential'
        },
        {
          key: 'curriculum.length',
          label: 'Curriculums'
        },
        {
          key: 'edit',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ]
    }
  },
  validations: {
    formSelectionProcess: {
      title: { required },
      position: { required },
      endDate: {
        required,
        minValue(val) {
          var date = moment(val, 'DD-MM-YYYY').toDate()
          var todayDate = moment().toDate()
          todayDate.setHours(0, 0, 0, 0)
          return date >= todayDate
        },
      },
      startPublish: {
        minValue(startVal, { publish }) {
          if (!publish) return true;
          var startDate = moment(startVal, 'DD-MM-YYYY').toDate()
          var todayDate = moment().toDate()
          todayDate.setHours(0, 0, 0, 0)
          return startDate >= todayDate
        },
        maxValue(startVal, { endPublish, publish }) {
          if (!publish) return true;
          var startDate = moment(startVal, 'DD-MM-YYYY').toDate()
          var endDate = moment(endPublish, 'DD-MM-YYYY').toDate()
          var result = startDate <= endDate
          return result
        }
      },
      endPublish: {
        minValue(endVal, { startPublish, publish }) {
          if (!publish) return true;
          var startDate = moment(startPublish, 'DD-MM-YYYY').toDate()
          var todayDate = moment().toDate()
          todayDate.setHours(0, 0, 0, 0)
          var endDate = moment(endVal, 'DD-MM-YYYY').toDate()
          return endDate >= startDate && endDate >= todayDate
        }
      },
    },
    file: {
      file: {
        required
      },
      name: {
        required
      }
    }
  },
  computed: {
    endDateVal() {
      // `this` points to the component instance
      if (this.formSelectionProcess.endDate) {
        return moment(this.formSelectionProcess.endDate, "DD/MM/YYYY").toDate()
      } else {
        return null
      }
    },
    startPublishVal() {
      // `this` points to the component instance
      if (this.formSelectionProcess.startPublish) {
        return moment(this.formSelectionProcess.startPublish, "DD/MM/YYYY").toDate()
      } else {
        return null
      }
    },
    endPublishVal() {
      // `this` points to the component instance
      if (this.formSelectionProcess.endPublish) {
        return moment(this.formSelectionProcess.endPublish, "DD/MM/YYYY").toDate()
      } else {
        return null
      }
    },
    ...authComputed,
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.currentPage = value
        this.search()
      }
    },
    currentPageDeleted: {
      handler: function (value) {
        this.currentPageDeleted = value
        this.searchInactive()
      }
    }
  },
  created() {
    this.loadAFP()
    this.search()
    this.searchInactive()
  },
  methods: {
    editCandidates(item) {
      this.idSelected = item.id
      this.showManager(true)
    },
    showManager(value) {
      this.showCurriculumManager = value
    },
    checkPermission(roles) {
      return roles.some((r) => this.currentUser.userRoles.includes(r))
    },
    viewSelectionProcess(item) {
      this.idSelected = item.id
      this.$refs['modalViewSelectionProcess'].show()
    },
    editSelectionProcess(item) {
      this.$v.formSelectionProcess.$reset()
      this.isLoading = true
      axios.get(`${appConfig.apiUrl}selection-process/${item.id}`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          this.openModalAddSelectionProcess()
          this.formSelectionProcess = response.data
          // this.$refs['modalEditSelectionProcess'].show()
          this.formSelectionProcess.endDate = moment(response.data.endDate).format("DD/MM/YYYY")
          this.formSelectionProcess.startPublish = moment(response.data.startPublish).format("DD/MM/YYYY")
          this.formSelectionProcess.endPublish = moment(response.data.endPublish).format("DD/MM/YYYY")
          this.fileItems = this.formSelectionProcess.selectionProcessFile
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    openModalAddSelectionProcess() {


      this.formSelectionProcess = {}

      this.fileItems = []
      this.file = {}

      this.formSelectionProcess = {
        selectionProcessStatusId: 1,
        selectionProcessOnGoingStatusId: 1,
        startPublish: null,
        endPublish: null,
        endDate: null
      }
      this.$v.formSelectionProcess.$reset()
      this.$refs['modalEditSelectionProcess'].show()
    },
    hideModalSaveSelectionProcess() {
      this.$refs['modalEditSelectionProcess'].hide()
    },
    confirmEditSelectionProcess() {
      // this.$v.formSelectionProcess.$reset()
      this.$v.formSelectionProcess.$touch()
      if (this.$v.formSelectionProcess.$anyError) {
        this.$notify({ group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.' })
        return false
      } else {
        this.isLoading = true
        let selProc = this.formSelectionProcess
        selProc.endDate = moment(this.formSelectionProcess.endDate, "DD/MM/YYYY").format("MM/DD/YYYY")

        if (selProc.publish) {
          selProc.startPublish = moment(this.formSelectionProcess.startPublish, "DD/MM/YYYY").format("MM/DD/YYYY")
          selProc.endPublish = moment(this.formSelectionProcess.endPublish, "DD/MM/YYYY").format("MM/DD/YYYY")
        } else {
          selProc.startPublish = null
          selProc.endPublish = null
        }

        axios.put(appConfig.apiUrl + 'selection-process/update',
          qs.stringify(selProc),
          { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
          .then(response => {
            this.$notify({ group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.' });
            this.$refs['modalEditSelectionProcess'].hide()
          })
          .catch(error => {
            this.loginCheck(error.response.status)
            this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
          })
          .finally(() => {
            this.search()
            this.searchInactive()
            this.isLoading = false
          })
      }
    },
    confirmSaveSelectionProcess() {
      // this.$v.formSelectionProcess.$reset()
      this.$v.formSelectionProcess.$touch()
      if (this.$v.formSelectionProcess.$anyError) {
        this.$notify({ group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.' })
        return false
      } else {
        this.isLoading = true
        let selProc = this.formSelectionProcess
        selProc.endDate = moment(this.formSelectionProcess.endDate, "DD/MM/YYYY").format("MM/DD/YYYY")
        selProc.startPublish = moment(this.formSelectionProcess.startPublish, "DD/MM/YYYY").format("MM/DD/YYYY")
        selProc.endPublish = moment(this.formSelectionProcess.endPublish, "DD/MM/YYYY").format("MM/DD/YYYY")
        axios.post(appConfig.apiUrl + 'selection-process/add',
          qs.stringify(selProc),
          { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
          .then(response => {
            this.$notify({ group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.' });
            this.hideModalSaveSelectionProcess()
            this.idSelected = response.data.id
            this.showCurriculumManager = true
          })
          .catch(error => {
            this.loginCheck(error.response.status)
            this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
          })
          .finally(() => {
            this.search()
            this.searchInactive()
            this.isLoading = false
          })
      }
    },
    clearForm() {
      this.formSearch = {
        agencyId: null,
        SelectionProcessStatusId: null
      }
      this.ongoing = false
    },
    loadAFP() {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'agency',
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          this.agencies = response.data
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error })
        })
        .finally(() => {
          this.loadStatus()
        })
    },
    loadStatus() {
      this.isLoading = true
      axios.get(`${appConfig.apiUrl}selection-process/status`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          this.status = response.data
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error })
        })
        .finally(() => {
          this.loadOngoingStatus()
        })
    },
    loadOngoingStatus() {
      this.isLoading = true
      axios.get(`${appConfig.apiUrl}selection-process/ongoing-status`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          this.statusOngoing = response.data
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    searchAll() {
      this.search()
      this.searchInactive()
    },
    search() {
      this.isLoading = true
      axios.post(appConfig.apiUrl + 'selection-process/search',
        qs.stringify({
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          filter: this.formSearch,
          ongoing: this.ongoing,
          deleted: false
        }),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.currentPage = response.data.currentPage
          this.perPage = response.data.pageSize
          this.totalItems = response.data.rowCount
          this.searchResult = response.data.results
          this.pageCount = response.data.pageCount
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    exportData() {
      this.isLoading = true
      axios.post(`${appConfig.apiUrl}dashboard/selection-process/export`,
        qs.stringify({
          dados: this.formSearch
        }),
        {
          headers: { Authorization: `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' },
          responseType: 'blob'
        })
        .then(response => {
          if (response.data) {
            var blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'Export.xlsx')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    searchInactive() {
      this.isLoading = true
      axios.post(appConfig.apiUrl + 'selection-process/search',
        qs.stringify({
          pageNumber: this.currentPageDeleted,
          pageSize: this.perPageDeleted,
          filter: this.formSearch,
          ongoing: this.ongoing,
          deleted: true
        }),
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.currentPageDeleted = response.data.currentPage
          this.perPageDeleted = response.data.pageSize
          this.totalItemsDeleted = response.data.rowCount
          this.searchResultDeleted = response.data.results
          this.pageCountDeleted = response.data.pageCount
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    changeStatusSelectionProcess(selectionProcessId, action) {
      this.$bvModal.msgBoxConfirm(`Do you really want to ${action ? 'activate' : 'deactivate'} the selection process?`, {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Yes',
        cancelTitle: 'No',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            this.changeStatus(selectionProcessId, action ? 'active' : 'inactive')
          }
        })
        .catch(err => {
          console.log(err)
        })

    },
    changeStatus(selectionProcessId, route) {
      axios.put(`${appConfig.apiUrl}selection-process/${selectionProcessId}/${route}`, null,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          this.search()
          this.searchInactive()
          this.$notify({ group: 'alert', type: 'success', title: 'Success', text: 'Save Successful.' });
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        });
    },
    updateEndDate(value) {
      if (value) {
        var newDate = moment(value).format("DD/MM/YYYY")
        this.formSelectionProcess.endDate = newDate
      }
    },
    onBlurEndDate(ctx) {
      this.formSelectionProcess.endDate = ctx.target.value
    },
    updateStartPublish(value) {
      if (value) {
        this.formSelectionProcess.startPublish = moment(value).format("DD/MM/YYYY")
      }
    },
    onBlurStartPublish(ctx) {
      this.formSelectionProcess.startPublish = ctx.target.value
    },
    updateEndPublish(value) {
      if (value) {
        this.formSelectionProcess.endPublish = moment(value).format("DD/MM/YYYY")
      }
    },
    onBlurEndPublish(ctx) {
      this.formSelectionProcess.endPublish = ctx.target.value
    },
    addFile() {
      this.newFile = true
      this.file = {}
      this.$refs['modalFile'].show()
    },
    checkFileSize() {
      if (!this.file.file) {
        return true
      }
      return (this.file.file.size / 1024 / 1024 < this.agency.maxFileSize)
    },
    hideModalFile() {
      this.$refs['modalFile'].hide()
      this.$v.file.$reset()
    },
    hideModalEditFile() {
      this.$refs['modalFile'].hide()
      this.$v.file.$reset()
    },
    deleteFile(item) {
      this.file = item
      this.$refs['modalconfirmDelete'].show()
    },
    hideConfirmDelete() {
      this.$refs['modalconfirmDelete'].hide()
    },
    editFile(item) {
      console.log(item)
      this.file = item
      // this.file.file = this.file.originalName
      this.$refs['modalFile'].show()
    },
    downloadFile(item) {
      this.isLoading = true
      console.log(this.user.access_token)
      axios.get(appConfig.apiUrl + `file/download/${item.id}`,
        {
          headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' },
          responseType: 'blob'
        })
        .then((response) => {
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.originalName);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    saveFile() {
      this.$v.file.$touch()
      if (this.$v.file.$anyError) {
        this.$notify({ group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.' });
        return
      }

      if (!this.checkFileSize()) {
        this.$notify({ group: 'alert', type: 'error', title: 'Form Validation', text: `The maximum file size allowed is ${this.agency.maxFileSize} MB.` });
        return
      }

      let formData = new FormData();
      formData.append('files', this.file.file);
      formData.append('file.name', this.file.name);
      formData.append('file.selectionProcessFile[0].selectionProcessId', this.formSelectionProcess.id);

      if (this.file.description) {
        formData.append('file.description', this.file.description);
      }

      this.isLoading = true
      axios.post(appConfig.apiUrl + 'file/save', formData,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'multipart/form-data' } })
        .then((response) => {
          this.hideModalFile()
          this.loadSelectionProcess(true)
          this.isLoading = false
        })
        .catch(error => {
          alert(error)
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
          this.isLoading = false
        })
    },
    confirmDelete() {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `file/${this.file.id}`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({ group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.' });
          this.loadSelectionProcess(true)
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'error', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
          this.hideConfirmDelete()
        })
    },
    loadSelectionProcess(justFiles = false) {
      this.isLoading = true
      axios.get(`${appConfig.apiUrl}selection-process/${this.formSelectionProcess.id}`,
        { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then((response) => {
          if(justFiles){
            this.fileItems = response.data.selectionProcessFile
          }
          else {
            this.formSelectionProcess = response.data
            this.formSelectionProcess.endDate = moment(response.data.endDate).format("DD/MM/YYYY")
            this.formSelectionProcess.startPublish = moment(response.data.startPublish).format("DD/MM/YYYY")
            this.formSelectionProcess.endPublish = moment(response.data.endPublish).format("DD/MM/YYYY")
            this.fileItems = this.formSelectionProcess.selectionProcessFile
          }
          
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
